// add all constant in this file

export const manualOptions = [
  { value: "New Lead", label: "New Lead", color: "#E6F9FF" },
  { value: "Contacted", label: "Contacted", color: "#FFD699" },
  { value: "Lost", label: "Lost", color: "#FFEBEB" },
  { value: "Invalid", label: "Invalid", color: "#F2F2F2" },
];

export const filterOptions = [
  { value: "All", label: "All", color: "#E6F9FF" },
  { value: "New Lead", label: "New Leads", color: "#E6F9FF" },
  { value: "Contacted", label: "Contacted", color: "#FFD699" },
  { value: "Offer sent", label: "Offer Sent", color: "#FFCCE5" },
  { value: "Won", label: "Won", color: "#D9F7BE" },
  { value: "Lost", label: "Lost", color: "#FFEBEB" },
  { value: "Invalid", label: "Invalid", color: "#F2F2F2" },
];

export const backendOptions = [
  { value: "Offer Sent", label: "Offer Sent", color: "#FFCCE5" },
  { value: "Won", label: "Won", color: "#D9F7BE" },
];
